/* ***************************************************************************
* @author Afonso Bordado (abordado@mobinteg.com)
* @author mfranco (mfranco@mobinteg.com)
*******************************************************************************/

import React, { Component } from "react"
import DebtPhaseDocuments from "../../components/DebtPhaseDocuments"
import ExecutionDetails from "../../components/ExecutionDetails"
import DebtPhaseOptions from "../../components/DebtPhaseOptions"
import DebtPhaseExpenses from "../../components/DebtPhaseExpenses"
import ExtraExecutionDetails from "../../components/ExtraExecutionDetails"
import SaveButton from "../../components/SaveButton"
import { connect } from "react-redux"
import { getExecutionById } from "../../actions"
import * as strings from "../../strings"
import DebtSummaryHeader from "../../components/DebtSummaryHeader"
import BigList from "../../components/BigList"
import Hidable from "../../components/Hidable"
import style from "./style.css"
import _ from "lodash"
import { toastr } from "react-redux-toastr"
import {
  getDebtById,
  updateExecution,
} from "../../actions"
import {
  cleanupOption,
} from "../../utils"

const ERROR_TAB = <div className={style.errorTab}>{strings.processes.withoutPrecedents}</div>


class ExecutionView extends Component {
  props: {
    debt: any,
    getDebtById: any,
    suggestions: any,
    auth: {
      token: string,
    },
    history: any,
    match: {
      path: string,
      params: {
        executionId: string,
      },
    },

    mainContactId: number,
    contacts: any[],
  }

  state = {
    showLitigation: true,
    request: {
      execution: undefined,
    },
    execution: undefined,
  }

  fetchExecution = executionId => getExecutionById( this.props.auth.token, executionId )
    .then( response => new Promise( res => {
      const execution = ( response.message !== strings.generalStrings.ok.toUpperCase() ) ?
        null : response.result

      this.setState( {
        request: {
          ...this.state.request,
          execution,
        },
        execution,
      }, res )
    } ) )

  componentWillMount = () => {
    const executionId = parseInt( this.props.match.params.executionId, 10 )
    this.fetchExecution( executionId )
      .then( () => {
        this.props.getDebtById( this.state.execution.idDebt )
      } )
  }

  renderDetails = mainDebtor => (
    <ExecutionDetails
      execution={this.state.execution}
      mainDebtor={mainDebtor}
      onChange={newDetails => {
        this.setState( {
          execution: {
            ...this.state.execution,
            ...newDetails,
          },
        } )
      } }
    />
  )


  renderExtraExecutionDetails = () => {
    return (
      <ExtraExecutionDetails
        execution={this.state.execution}
        isRequestExecution={_.isEqual( this.state.request.execution, this.state.execution )}
        courts={this.props.suggestions.courts}
        debt={this.props.debt}
        onChange={newDetails => this.setState( {
          execution: {
            ...this.state.execution,
            ...newDetails,
          },
        } ) }
      />
    )
  }

  renderDocuments = execution => {
    return (
      <DebtPhaseDocuments
        documents={execution.documents}
        onChange={newDocuments => this.updateExecutionAndRequest( {
          documents: newDocuments,
        } )}

        phaseId={execution.id}
        fileDownloadCommand="getExecutionDocument"

        fileRemoveCommand="removeExecutionDocument"
        fileUploadCommand="newExecutionDocuments"
        fileUploadArgs={{
          id: execution.id,
        }}
      />
    )
  }

  updateExecutionAndRequest = newData => {
    const newExecution = {
      ...this.state.execution,
      ...newData,
    }

    this.setState( {
      request: {
        ...this.state.request,
        execution: newExecution,
      },
      execution: newExecution,
    } )
  }

  save = () => {
    const { execution } = this.state
    const preparedExecution = _.omit( execution, [
      "totalValue", "idDebt", "otherExpenses", "documents",
      "debtValue", "debt", "court", "capitalValue", "expenses",
      "observations", "litigationExecutions",
    ] )

    const executionFormatted = {
      ...preparedExecution,
      justiceTax: execution.justiceTax ? parseFloat( execution.justiceTax ) : null,
      idCourt: execution.idCourt ? parseFloat( execution.idCourt ) : null,
      interestUntilLitigation: execution.interestUntilLitigation ? parseFloat( execution.interestUntilLitigation ) : null,
      interestFromRiUntilExecution: execution.interestFromRiUntilExecution ? parseFloat( execution.interestFromRiUntilExecution ) : null,
      interestCompulsory: execution.interestCompulsory ? parseFloat( execution.interestCompulsory ) : null,
      totalInterest: execution.totalInterest ? parseFloat( execution.totalInterest ) : null,
      activeOption: cleanupOption( execution.activeOption, [
        "validFrom",
        "type",
        "subtype",
        "state",
        "conclusionReason",
      ] ),
    }

    updateExecution( this.props.auth.token, executionFormatted )
      .then( res => {
        if ( res.message !== "OK" ) {
          throw "Failed saving"
        }

        return this.updateExecutionAndRequest( res.result )
      } )
      .then( () => toastr.success( strings.generalStrings.changesSaved ) )
      .catch( () => toastr.error( strings.generalStrings.errorSaving ) )
  }

  reset = () => this.setState( {
    execution: this.state.request.execution,
  } )

  renderTab = ( componentToRender, title, onToggle, expanded ) => {
    return (
      <Hidable
        title={title}
        onToggle={onToggle}
        expanded={expanded}
      >
        {componentToRender()}
      </Hidable>
    )
  }

  showLitigation = () => {
    this.setState( {
      showLitigation: !this.state.showLitigation,
    } )
  }

  renderLitigation = () => {
    const { generalStrings } = strings
    const userColumns = [
      { title: generalStrings.idc, key: "idc" },
      { title: generalStrings.type, key: "type" },
      { title: generalStrings.subType, key: "subType" },
      { title: generalStrings.state, key: "state" },
    ]

    const linkedLitigationIds = this.state.request.execution.litigationExecutions.map(
      litigationToExecution => litigationToExecution.idLitigation )
    const litigationProcedures = this.props.debt.litigations || []
    const filteredLitigationProcedures = litigationProcedures.filter( litigation => linkedLitigationIds.includes( litigation.id ) )
    const items = filteredLitigationProcedures.map( litigation => ( {
      idc: litigation.idc || "--",
      type: _.get( litigation, "activeOption.type.name", "--" ),
      subType: _.get( litigation, "activeOption.subtype.name", "--" ),
      state: _.get( litigation, "activeOption.state.name", "--" ),
      _onClick: () => this.props.history.push( "/litigation/" + litigation.id + "?executionId=" + parseInt( this.props.match.params.executionId, 10 ) ),
    } ) )

    return (
      <div className={this.state.showLitigation ? style.showContent : style.hiddenContent}>
        {filteredLitigationProcedures.length !== 0 ? this.renderBigList( items, userColumns ) : ERROR_TAB}
      </div>
    )
  }

  renderBigList = ( items, columns ) => {
    return <BigList
      loadMore={() => {}}
      hasMoreItems={() => false}
      items={ items }
      columns={ columns }
    />
  }


  render () {
    const { execution } = this.state
    // TODO: Some kind of loading animation
    // We can probably continue without debtorsInfo
    if ( execution === undefined || this.props.suggestions === undefined ) {
      return <div />
    }

    if ( execution === null ) { // TODO: Better error handling
      return (
        <div>
          {strings.errorMessages.anErrorHasOccurred}
        </div>
      )
    }

    return (
      <div>
        <DebtSummaryHeader
          title={strings.generalStrings.debt}
          debt={this.props.debt}
          isProcessPhase={true}
          lotId={execution.idLot} />
        <DebtPhaseOptions
          debtPhaseEnum="Execution"
          debtPhase={execution}
          debt={this.props.debt}
          debtPhaseId={parseInt( this.props.match.params.executionId, 10 )}
          onChange={newDetails => this.setState( {
            execution: {
              ...this.state.execution,
              activeOption: {
                ...this.state.execution.activeOption,
                ...newDetails,
              },
            },
          } ) }
          parentOption={this.state.execution.activeOption}/>
        {this.renderTab( this.renderLitigation, strings.processes.previousInjunctions, this.showLitigation, this.state.showLitigation )}
        {this.renderExtraExecutionDetails()}
        <DebtPhaseExpenses
          expenses={this.state.execution.expenses}
        />
        {this.renderDocuments( execution )}
        <SaveButton
          onSave={this.save}
          onCancel={this.reset}
          show={
            !_.isEqual( this.state.request.execution, this.state.execution )
          }
        />
      </div>
    )
  }
}


export default connect( store => ( { auth: store.auth, debt: store.getDebt, suggestions: store.suggestions } ), { getDebtById } )( ExecutionView )



// WEBPACK FOOTER //
// ./src/views/ExecutionView/index.jsx